import {
    faBed,
    faCalendarWeek,
    faHouse,
    faVenus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Image, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import {
    Blood,
    Card1,
    Filter,
    General,
    Heart,
    Icon_Circle,
    Oxygen,
    Patient,
    Sugar,
    Temperature,
    bodyscale,
    siren,
} from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import CustomTab from "../../../../Helper/customTabs";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import Lab from "../../../Tabs/Lab";


const CaseDetailLab = () => {
    const breadcrumData = ['Dashboard', 'Cardiology', 'Patient List'];
    const breadcrumItem = ['Case Detail'];

    const [currentTab, setCurrentTab] = useState("1");
    const tabs = [
        {
            id: 1,
            tabTitle: "Lab",
        },
    ];

    return (
        <div className="patient_details_screen">
            <WithoutImageHeader
                header={Constants.CASE_DETAIL}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <>
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}  >
                            <div className="patient_details">
                                <div className="main_detail">
                                    <div className="left_area">
                                        <div className="inner_left">
                                            <div className="img_area" >
                                                <Image
                                                    variant="left"
                                                    src={Patient}
                                                    alt="..."
                                                />
                                            </div>
                                        </div>
                                        <div className="inner_right">
                                            <div className="name" >
                                                <h3 style={{ textTransform: 'capitalize' }} >
                                                    Patient Name
                                                </h3>
                                                <a>
                                                    <div className="img_icon">
                                                        <img src={Icon_Circle} alt="..." />
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="gender">
                                                <p>
                                                    <FontAwesomeIcon
                                                        icon={faVenus}
                                                        className="gender_icon"
                                                    />
                                                    Female
                                                </p>
                                                <p>
                                                    <span>
                                                        Cardiology
                                                    </span>
                                                </p>

                                                <p className="general">
                                                    <Image
                                                        src={General} alt="..." className="general_img"
                                                    />
                                                    General
                                                </p>

                                                <p className="general emergency">
                                                    <Image src={siren} alt="..." className="general_img" />
                                                    Emergency
                                                </p>

                                            </div>
                                            <div className="date">

                                                <p>
                                                    <FontAwesomeIcon icon={faCalendarWeek} className="date_icon" />
                                                    5 July, 2023
                                                </p>


                                                <p className="bed_space">
                                                    <FontAwesomeIcon icon={faBed} className="date_icon ps-4" /> Bed #
                                                </p>

                                                <p>
                                                    <FontAwesomeIcon icon={faHouse} className="date_icon ps-4" /> Room #
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="id_area">
                                            <p>
                                                UHID :gggg
                                            </p>
                                        </div>
                                        {/* <div className="batch">
                                            <p class="discharge">Discharge</p>
                                        </div> */}
                                        <Dropdown>
                                            <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                <div className="batch orange_bg">
                                                    <p class="warning">Under Treatment</p>
                                                </div>
                                                {/* <div className="batch danger">
                                                                            <p class="danger">Critical</p>
                                                                        </div>
                                                                            <div className="batch success">
                                                                                <p class="success">Admitted</p>
                                                                            </div>
                                                                                <div className="batch discharges">
                                                                                    <p class="discharge">Discharge</p>
                                                                                </div> */}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item>
                                                    fhjfhjf
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="health_area">
                                    <div className="title_area">
                                        <h5>Health Overview</h5>
                                        <p>
                                            Last Update :fklkflklf
                                        </p>
                                    </div>
                                    <div className="cards_area">
                                        <Row>
                                            <Col xl={6} lg={6} md={6} sm={6} xs={12} >
                                                <div className="card_inner_area">
                                                    <div className="sub_area">
                                                        <div className="left_area heart">
                                                            <div className="img_area">
                                                                <Image src={Heart} alt="..." />
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <h5>
                                                                Heart
                                                                Rate
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="bottom_area">
                                                        <p>
                                                            <span>
                                                                89
                                                                {/* {patientData.vitals[0].heart_beat} */}
                                                            </span>
                                                            bpm
                                                        </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}   >
                                                <div className="card_inner_area">
                                                    <div className="sub_area">
                                                        <div className="left_area blood">
                                                            <div className="img_area bloood">
                                                                <Image src={Blood} alt="..." />
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <h5>Blood Pressure</h5>
                                                        </div>
                                                    </div>
                                                    <div className="bottom_area">
                                                        <p>
                                                            <span>
                                                                102
                                                            </span>

                                                            mmhg
                                                        </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} >
                                                <div className="card_inner_area">
                                                    <div className="sub_area">
                                                        <div className="left_area oxygen">
                                                            <div className="img_area bloood">
                                                                <Image
                                                                    src={
                                                                        Oxygen
                                                                    }
                                                                    alt="..."
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <h5>
                                                                Oxygen
                                                                Saturation
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="bottom_area">
                                                        <p>
                                                            <span>97
                                                            </span>
                                                            %SpO2
                                                        </p>
                                                        <p>
                                                            <span className="oxygen">
                                                                60
                                                            </span>
                                                            PRbpm
                                                        </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col
                                                xxl={6}
                                                xl={6}
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <div className="card_inner_area">
                                                    <div className="sub_area">
                                                        <div className="left_area sugar">
                                                            <div className="img_area bloood">
                                                                <Image
                                                                    src={
                                                                        Sugar
                                                                    }
                                                                    alt="..."
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <h5>
                                                                Blood
                                                                Sugar
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="bottom_area">
                                                        <p>
                                                            <span>
                                                                140
                                                            </span>
                                                            mg/dl
                                                        </p>
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col
                                                xxl={6}
                                                xl={6}
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <div className="card_inner_area">
                                                    <div className="sub_area">
                                                        <div className="left_area sugar">
                                                            <div className="img_area bloood">
                                                                <Image
                                                                    src={
                                                                        bodyscale
                                                                    }
                                                                    alt="..."
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <h5>
                                                                Weight
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="bottom_area">
                                                        <p>
                                                            <span>
                                                                50
                                                            </span>
                                                            Kg
                                                        </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col
                                                xxl={6}
                                                xl={6}
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <div className="card_inner_area">
                                                    <div className="sub_area">
                                                        <div className="left_area">
                                                            <div className="img_area">
                                                                <Image
                                                                    src={
                                                                        Temperature
                                                                    }
                                                                    alt="..."
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <h5>
                                                                Temperature
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="bottom_area">
                                                        <p>
                                                            <span class="circle">
                                                                40
                                                            </span>
                                                            Celsius
                                                        </p>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="last_update">
                                        Last updated by: Jospeh Jones
                                    </div>
                                </div>
                                <div className="accordin_area" >
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                Medical Record: #1
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="case_detail_area">
                                                    <div class="title">
                                                        <h5>ggfgfgf</h5>
                                                    </div>
                                                </div>
                                                <div className="inner_area">

                                                    <h5>Active</h5>
                                                    <div className="description">
                                                        <p>hghgg</p>
                                                    </div>
                                                    <div className="btn_active_area">
                                                        <a href="javascript:;" className="active">Active</a>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="task_btn_area">
                    <CustomTab
                        tabs={tabs}
                        currentTab={currentTab}
                        setCurrentTab={(e) => setCurrentTab(e)}
                    />
                </div>
                <div className="tab_details">
                    <div className="custom_tab_data">
                        <Lab />
                    </div>
                </div>
            </>
        </div>
    );
};

export default CaseDetailLab;
